export default {
  TYPE: [
    { KEY: 'COMPANY', VALUE: 'Vale-Transporte' },
    { KEY: 'USER', VALUE: 'Usuário' },
    { KEY: 'SCHOOL', VALUE: 'Instituição de Ensino' },
  ],
  STATUS: [
    { KEY: 0, VALUE: 'Criado' },
    { KEY: 1, VALUE: 'Em Processamento' },
    { KEY: 2, VALUE: 'Completado' },
    { KEY: 3, VALUE: 'Erro' },
    { KEY: 4, VALUE: 'Expirado' },
    { KEY: 5, VALUE: 'Cancelado' },
  ],
  PAYMENT_TYPE: [
    { KEY: 'CREDIT_CARD_CLEAN', VALUE: 'Cartão de Crédito (CLEAN)' },
    { KEY: 'CREDIT_CARD', VALUE: 'Cartão de Crédito' },
    { KEY: 'BOLETO', VALUE: 'Boleto' },
    { KEY: 'PIX', VALUE: 'PIX' },
    { KEY: 'MONEY', VALUE: 'Dinheiro' },
    { KEY: 'VOUCHER', VALUE: 'Voucher' },
    { KEY: 'REQUISITION', VALUE: 'Requisição' },
    { KEY: 'FREE', VALUE: 'Gratuidade' },
    { KEY: 'POS_PAID', VALUE: 'Pós-Pago' },
    { KEY: 'EXTERNAL', VALUE: 'Pagamento Externo' },
    { KEY: 'DEBIT_CARD', VALUE: 'Cartão de Débito' },
    { KEY: 'PINPAD_DEBIT_CARD', VALUE: 'Cartão de Débito Pinpad' },
    { KEY: 'PINPAD_CREDIT_CARD', VALUE: 'Cartão de Crédito Pinpad' },
  ],
  STATUS_ORDER: [
    { KEY: 0, VALUE: 'Não Liberado' },
    { KEY: 1, VALUE: 'Liberado' },
  ],
  ERROR: 3,
  PIX: 'PIX',
  DEBIT_CARD: 'DEBIT_CARD',
  CREDIT_CARD: 'CREDIT_CARD',
  PINPAD_DEBIT_CARD: 'PINPAD_DEBIT_CARD',
  PINPAD_CREDIT_CARD: 'PINPAD_CREDIT_CARD',
  CREDIT_CARD_CLEAN: 'CREDIT_CARD_CLEAN',
  BOLETO: 'BOLETO',
  MONEY: 'MONEY',
  VOUCHER: 'VOUCHER',
  REQUISITION: 'REQUISITION',
  FREE: 'FREE',
  POS_PAID: 'POS_PAID',
  EXTERNAL: 'EXTERNAL',
};
